const coupons = [
    { name: "SAVE100", value: 100 },
    { name: "DISCOUNT200", value: 200 },
    { name: "HALFOFF300", value: 300 },
    { name: "SALE400", value: 400 },
    { name: "DEAL500", value: 500 }
];

const returnRatio = [
    {
        name: 'Preview week',
        percentage: 50,
    },
    {
        name: 'Last 7 days',
        percentage: 20,
    },
];

const productReviews = [
    {
        name: 'Excellent reviews',
        percentage: 37.5,
        reviews: 5470,
    },
    {
        name: 'Fair Reviews',
        percentage: 57.5,
        reviews: 670,
    },
    {
        name: 'Need Improvement',
        percentage: 20,
        reviews: 5169,
    },
]

export {
    coupons,
    returnRatio,
    productReviews
};